<div class="callout alert" data-closable *ngIf="errorMessage">
  {{errorMessage}}
</div>
<div class="callout success" data-closable *ngIf="successMessage">
  {{successMessage}}
</div>
<div class="callout alert" data-closable *ngIf="errorsList.length>0">
  <div *ngFor="let error of errorsList; let i=index">
    {{error}}
  </div>
</div>
